import { render } from "./JourneyListScreen.vue?vue&type=template&id=742a1398&scoped=true"
import script from "./JourneyListScreen.vue?vue&type=script&lang=js"
export * from "./JourneyListScreen.vue?vue&type=script&lang=js"

import "./JourneyListScreen.vue?vue&type=style&index=0&id=742a1398&scoped=true&lang=css"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742a1398"]])

export default __exports__